import { Fragment } from "react";
import { CheckIcon } from "./Icons";

const LABELS = ["Verify email", "Verify mobile", "New password"];

// Flow A only — Flow B has no stepper
const Stepper = ({ current }) => (
  <div className="flex items-center gap-2 mb-6">
    {LABELS.map((label, index) => {
      const done = index < current;
      const active = index === current;
      return (
        <Fragment key={label}>
          {index > 0 && (
            <span
              className={`flex-1 h-[1.5px] min-w-[8px] ${done || active ? "bg-success" : "bg-[#E3E4E8]"}`}
            />
          )}
          <div className="flex items-center gap-1.5 shrink-0">
            <span
              className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-geomanistMedium
                ${done ? "bg-success text-white" : ""}
                ${active ? "bg-blueish text-white" : ""}
                ${!done && !active ? "border border-[#D3D4DA] text-geomanistgray" : ""}`}
            >
              {done ? <CheckIcon className="w-3.5 h-3.5" /> : index + 1}
            </span>
            <span
              className={`font-geomanistMedium text-xs leading-4 whitespace-nowrap
                ${done ? "text-success" : ""}
                ${active ? "text-blueish" : ""}
                ${!done && !active ? "text-geomanistgray" : ""}`}
            >
              {label}
            </span>
          </div>
        </Fragment>
      );
    })}
  </div>
);

export default Stepper;
